export default __webpack_public_path__ + "static/media/fl8.2ac078bd.jpg";